// @ts-nocheck
// datatable related plugins
import { yupResolver } from "@hookform/resolvers/yup";
import ConfirmModal from "components/shared-components/ConfirmModal";
import {
  MODE_INVOICE_ACTION,
  TYPE_ACTION_WORKFLOW,
  TYPE_INVOICE_ANOTHER,
} from "constants/IssueInvoiceConstant";
import { generateSelectField } from "helpers/form_helper_old";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useToasts } from "react-toast-notifications";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  actionWorkflowIssueInvoice,
  createIssueInvoice,
  createListProductInvoice,
  listInvoiceSymbol,
  resetActionWorkflowIssueInvoice,
  resetReplaceIssueInvoice,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
} from "store/auth/login/actionTypes";
import {
  ACTION_WORKFLOW_ISSUE_INVOICE_FAIL,
  ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS,
  ISSUE_INVOICE_CREATE_FAIL,
  ISSUE_INVOICE_CREATE_SUCCESS,
  REPLACE_ISSUE_INVOICE_FAIL,
  REPLACE_ISSUE_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import * as yup from "yup";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  KHHDON_LAST,
  KHMSHDON,
  getTypeWorkflowMessage,
  issueInvoiceModeList,
} from "../IssueInvoice/utils";
import DetailBill from "./modal/DetailBill";

const CreateWareHouses = props => {
  const [listTypeHD, setListTypeHD] = useState([]);

  // isOpenAction32Modal
  const [isOpenAction32Modal, setIsOpenAction32Modal] = useState(false);
  const toggleOpenAction32Modal = () =>
    setIsOpenAction32Modal(!isOpenAction32Modal);

  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);

  const dispatch = useDispatch();

  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const {
    errorList: errorInvoiceSymbolList,
    list: invoiceSymbolList,
    loadingList,
  } = invoiceSymbol;

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // store reducer
  const issueInvoice = useSelector(state => state.issueInvoice);
  const { type, workflowInvoice, create, currentTime } = issueInvoice;

  const history = useHistory();
  const [detailModal, setDetailModal] = useState(false);

  const [isSelectType, setIsSelectType] = useState(false);

  const [isRoleStore, setIsRoleStore] = useState(false);

  useEffect(() => {
    switch (type) {
      case ISSUE_INVOICE_CREATE_SUCCESS:
        if (dataInvoiceTemp) {
          //GỬi duyệt phiếu xuất kho
          toggleWorkflowModal();
          dispatch(
            actionWorkflowIssueInvoice(
              create.id,
              dataWorkflow.typeWorkFlow,
              null
            )
          );
        } else {
          // Tạo phiếu xuất kho
          history.push("/invoice-warehouses");
        }
        break;
      case ISSUE_INVOICE_CREATE_FAIL:
        break;
      case ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS: {
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkflow) + " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        toggleWorkflowModal();
        history.push("/invoice-warehouses");
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      }
      case ACTION_WORKFLOW_ISSUE_INVOICE_FAIL:
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkFlow) + " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_SUCCESS:
        addToast(
          `Lập phiếu xuất kho ${dataConfirmAction.infoTT32.text} thành công`,
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        setDataConfirmAction(null);
        history.push("/invoice-warehouses");
        dispatch(resetReplaceIssueInvoice());
        break;
      case REPLACE_ISSUE_INVOICE_FAIL:
        addToast(
          `Lập phiếu xuất kho ${dataConfirmAction.infoTT32.text} thất bại`,
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        setDataConfirmAction(null);
        dispatch(resetReplaceIssueInvoice());
        break;
    }
  }, [type]);

  useEffect(() => {
    if (invoiceSymbolList?.items && invoiceSymbolList?.items.length > 0) {
      const data = invoiceSymbolList?.items[0];
      if (getValues("typeHD")) {
        const label =
          getValues("typeHD").ttchung_khmshdon +
          getValues("typeHD").khhdonDefault +
          data.khhdon;
        const value = getValues("typeHD").khhdonDefault + data.khhdon;
        setValue(
          "khhdon",
          {
            value,
            label,
          },
          {
            shouldValidate: true,
          }
        );
      }
    } else {
      setValue("khhdon", null);
    }
  }, [invoiceSymbolList]);

  useEffect(() => {
    if (finalBuInfo) {
      setIsSelectType(false);
      setValue("typeHD", {
        value: "",
        label: "",
      });
      setValue("khhdon", null);
      let listTypeHD = [];
      let curYear = currentTime?.data?.year.toString();
      curYear = curYear?.substr(curYear.length - 2);
      if (finalBuInfo) {
        if (finalBuInfo?.ctu === 1) {
          listTypeHD.push({
            value: `PAGE_DELIVERY_BILL_${
              finalBuInfo?.invoice_type === 1 ? "HAVE_CODE" : "NONE_CODE"
            }`,
            khhdonDefault: `${
              finalBuInfo?.invoice_type === 1 ? "C" : "K"
            }${curYear}${KHHDON_LAST.DELIVERY_BILL}`,
            mode: issueInvoiceModeList.CREATE_DELIVERY_BILL_DETAIL,
            ttchung_khmshdon: KHMSHDON.DELIVERY_BILL,
            label: `PHIẾU XUẤT KHO KIÊM VC NỘI BỘ ${
              finalBuInfo?.invoice_type === 1 ? "(CÓ MÃ)" : "(KHÔNG MÃ)"
            }`,
          });
        }
        setListTypeHD(listTypeHD);
      }
    }
  }, [finalBuInfo]);

  // Action Dispatch
  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
    }
  }, []);

  const actionReplaceOrAdjustInvoice = data => {
    const finalDataConfirm = {
      ...data,
      ...dataConfirmAction,
      mode: MODE_INVOICE_ACTION.REPLACE, // Lun hiểu ở Mức thay thế vì k có phiếu xuất kho cha để điều chỉnh
      typeAdjust: data.infoTT32.typeAdjust,
    };
    setDataConfirmAction(finalDataConfirm);
    toggleDetailModal();
  };

  const { addToast } = useToasts();

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);

  const schema = yup.object().shape({
    typeHD: yup.object().required("Vui lòng  chọn loại phiếu xuất kho"),
    khhdon: yup
      .object()
      .required("Vui lòng  chọn ký hiệu phiếu xuất kho")
      .nullable(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      typeHD: undefined,
      khhdon: undefined,
    },
  });

  // Workflow modal
  const [modalWorkflow, setModalWorkflow] = useState(false);
  const toggleWorkflowModal = () => setModalWorkflow(!modalWorkflow);
  const [dataWorkflow, setDataWorkflow] = useState({
    id: null,
    typeWorkFlow: null,
    titleModal: null,
    bodyModal: null,
  });

  // finalData: null,
  // typeAnother: null,
  // listProduct: [],
  const [dataInvoiceTemp, setDataInvoiceTemp] = useState(null);

  const [btnShowWhenCreate, setBtnShowWhenCreate] = useState({
    btnRelease: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
    btnSubmit: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
  });

  const onSubmit = values => {
    setDataConfirmAction(null);
    toggleDetailModal();
    generateButtonWhenCreate();
  };

  const onSubmitActionTT32 = () => {
    setBtnShowWhenCreate({
      btnRelease: {
        isShow: false,
        onClick: null,
      },
      btnSubmit: {
        isShow: false,
        onClick: null,
      },
    });
    toggleConfirmActionModal();
  };

  const generateButtonWhenCreate = () => {
    setBtnShowWhenCreate({
      btnRelease: {
        isShow: finalBuInfo?.need_approve === 0,
        onClick: null,
      },
      btnSubmit: {
        isShow: finalBuInfo?.need_approve === 1 && isRoleStore,
        onClick: null,
        toggleModal: () => {
          setDataWorkflow({
            typeWorkFlow: TYPE_ACTION_WORKFLOW.SUBMIT,
            titleModal: "Xác nhận gửi duyệt phiếu xuất kho",
            bodyModal: "Hệ thống sẽ gửi duyệt phiếu xuất kho này",
          });
          toggleWorkflowModal();
        },
      },
    });
  };

  const toggleDetailModal = (modeSet = "") => {
    setDetailModal(!detailModal);
  };

  return (
    <React.Fragment>
      {/* WORKFLOW modal */}
      <ConfirmModal
        isOpen={modalWorkflow}
        titleHeader={dataWorkflow.titleModal}
        titleBody={dataWorkflow.bodyModal}
        isDisableButton={workflowInvoice.loading}
        isHaveNote={dataWorkflow.typeWorkFlow === TYPE_ACTION_WORKFLOW.REJECT}
        onConfirm={note => {
          dispatch(createListProductInvoice(dataInvoiceTemp.listProduct));
          dispatch(
            createIssueInvoice(
              dataInvoiceTemp.finalData,
              dataInvoiceTemp.typeAnother
            )
          );
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleWorkflowModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>Lập phiếu xuất kho kiêm vc nội bộ</title>
        </MetaTags>
        <div className="container-fluid">
          {/* <ConfirmActionInvoiceTT32
            confirmActionData={dataConfirmAction}
            isOpen={modalConfirmAction}
            toggle={toggleConfirmActionModal}
            actionReplaceOrAdjustInvoice={actionReplaceOrAdjustInvoice}
          /> */}
          <Breadcrumbs
            title=""
            breadcrumbItem={"Lập phiếu xuất kho kiêm vc nội bộ"}
          />
          <Card>
            <CardBody style={{ minHeight: "450px" }}>
              <Row className="row-cols-1 row-cols-md-4 ">
                {/* Loại phiếu xuất kho */}
                <Col style={{}}>
                  {generateSelectField(
                    "Loại phiếu xuất kho",
                    true,
                    errors,
                    "typeHD",
                    "Vui lòng chọn",
                    false,
                    control,
                    listTypeHD,
                    "auto",
                    () => {
                      setIsSelectType(true);
                      const buTenant = localStorage.getItem("BU_STORE_HEADER");
                      // Get list ký hiệu phiếu xuất kho ( 2 ký tự cuối)
                      invoiceSymbolList.params.page = -1;
                      invoiceSymbolList.params.sort = "name";
                      invoiceSymbolList.params.columnFilter = {
                        "filter[record_status]": "O",
                        "filter[bu_code]": buTenant,
                        "filter[khmhdon]":
                          getValues("typeHD") &&
                          getValues("typeHD").ttchung_khmshdon,
                      };
                      invoiceSymbolList.params.fields =
                        "id,khmhdon,khhdon,bu_code,record_status,tenant_code,";
                      dispatch(listInvoiceSymbol(invoiceSymbolList.params));
                    },
                    false
                  )}
                  {listTypeHD.length > 0 ? (
                    <span
                      style={{ fontStyle: "italic" }}
                      className="text-primary font-size-15 mt-2"
                    >
                      *Chọn loại phiếu xuất kho và ký hiệu phiếu xuất kho muốn
                      lập
                    </span>
                  ) : (
                    <span
                      style={{ fontStyle: "italic" }}
                      className="text-danger font-size-15 mt-2"
                    >
                      *Chưa được phép lập phiếu xuất kho. Vui lòng tạo tờ khai
                      đăng ký sử dụng phiếu xuất kho
                    </span>
                  )}
                </Col>
                {/* Ký hiệu phiếu xuất kho */}
                <Col style={{ width: "200px" }}>
                  {generateSelectField(
                    "Ký hiệu phiếu xuất kho",
                    true,
                    errors,
                    "khhdon",
                    "Vui lòng chọn",
                    false,
                    control,
                    getValues("typeHD") && getValues("typeHD").ttchung_khmshdon
                      ? invoiceSymbolList?.items.map(item => {
                          const label =
                            getValues("typeHD").ttchung_khmshdon +
                            getValues("typeHD").khhdonDefault +
                            item.khhdon;
                          const value =
                            getValues("typeHD").khhdonDefault + item.khhdon;
                          return {
                            value: value,
                            label: label,
                          };
                        })
                      : [],
                    "auto",
                    () => {},
                    false
                  )}
                </Col>
                <Col style={{ marginTop: "28px", width: "210px" }}>
                  <Button
                    type="button"
                    color="primary"
                    className="me-2 btn-label"
                    disabled={loadingList || !isSelectType}
                    onClick={() => {
                      handleSubmit(onSubmit)();
                    }}
                  >
                    <i className="bx bx-receipt label-icon" />
                    Lập phiếu xuất kho
                  </Button>
                </Col>
                <Col style={{ marginTop: "28px", width: "214px" }}>
                  <Button
                    color="danger"
                    className=" w-md"
                    type="submit"
                    onClick={() => {
                      history.push("/invoice-warehouses");
                    }}
                  >
                    Trở về danh sách
                  </Button>
                </Col>
              </Row>
              {/* Detail Modal */}
              <DetailBill
                dataConfirmAction={dataConfirmAction}
                isOpenModal={detailModal}
                btnShowWhenCreate={btnShowWhenCreate}
                toggleModal={toggleDetailModal}
                khhdonDefault={getValues("khhdon") && getValues("khhdon").value}
                mode={getValues("typeHD") && getValues("typeHD").mode}
                pageView={getValues("typeHD") && getValues("typeHD").value}
                invoiceSymbolList={invoiceSymbolList.items}
                setDataInvoiceTemp={setDataInvoiceTemp}
                typeInvoiceAnother={TYPE_INVOICE_ANOTHER.DELIVERY_BILL}
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateWareHouses;
